import React from "react";
import ReactDOM from "react-dom/client";
// Шрифты системы «Протокол»: самохост, кириллица, font-display: swap
import "@fontsource-variable/inter";
import "@fontsource-variable/inter-tight";
import "@fontsource-variable/jetbrains-mono";
// Unbounded — фирменный шрифт логотипа «РешAI» (только wordmark)
import "@fontsource-variable/unbounded";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { initAnalytics } from "@/lib/analytics";
import { setImageLoadConcurrency } from "@/utils/imageLoadQueue";

initAnalytics();

const imageConcurrency = parseInt(process.env.REACT_APP_IMAGE_LOAD_CONCURRENCY || "4", 10);
if (Number.isFinite(imageConcurrency)) {
  setImageLoadConcurrency(imageConcurrency);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
